const name = 'circle-f';

const contents = '<path fill="#FFF" d="M27.479 55h-5.635V26.829h18.312v4.64H27.479v7.457H38.25v4.64H27.479z"/>';

/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'F',
};

export default icon;
